import React from 'react';
import { Router } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';

import './config/reactotron-config';
import './config/amplify-config';
import './config/toast-config';

import client from './services/api';
import history from './services/history';

import Routes from './routes/';
import GlobalStyle from './styles/global';

import { store, persistor } from './store';

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ApolloProvider client={client}>
          <ApolloHooksProvider client={client}>
            <Router history={history}>
              <Routes />
              <GlobalStyle />
            </Router>
          </ApolloHooksProvider>
        </ApolloProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
